import axios from '@/utils/request'
var Qs = require('qs')
export default {
	// 2021-09-18
	productNoSearch(params) {
		return axios.get('/weddingDressHall/inventory/product-no-search', params)
	},
	// 2021-09-19
	// productNo color size shopId
	findByProductInfo(params) {
		return axios.get('/weddingDressHall/inventory/find-by-product-info', params)
	},
	//   // 2020-09-28
	//   // productNo color size
	//   findByProductInfoWithoutShop(params) {
	//     return axios.get('/weddingDressHall/inventory/find-by-product-info-without-shop', params)
	//   },
	// 2021-09-22
	// productNo color size
	shopQuantityCount(params) {
		return axios.get('/weddingDressHall/inventory/shop-quantity-count', params)
	},
	//   // 2020-10-26
	//   // productNo color shopId
	//   findByProductInfoWithoutSize(params) {
	//     return axios.get('/weddingDressHall/inventory/find-by-product-info-without-size', params)
	//   },
	//   // 2021-07-01
	//   // productNo color
	//   findByProductInfoWithNoAndColor(params) {
	//     return axios.get('/weddingDressHall/inventory/find-by-product-info-with-no-and-color', params)
	//   },
	//   // 2020-12-12
	//   // productNo
	//   findByProductNoWithAllShop(params) {
	//     return axios.get('/weddingDressHall/inventory/find-by-product-no-with-all-shop', params)
	//   },

	// 2021-09-22
	// shopId productNo
	// findByProductInfoWithNoAndShop(params) {
	// 	return axios.get('/weddingDressHall/inventory/find-by-product-info-with-no-and-shop', params)
	// },
	// shopId productNo
	findByNoAndShop(params) {
		return axios.get('/weddingDressHall/inventory/find-by-no-and-shop', params)
	},
	// 2021-09-19
	batchCheck(params) {
		return axios.post('/weddingDressHall/inventory/batch-check', params)
	},
	// 2020-09-22
	updateWarnQuantity(id, params) {
		return axios.put('/weddingDressHall/inventory/' + id + '/update-warn-quantity', params)
	},
	// 2021-09-22
	updateRemark(id, params) {
		return axios.put('/weddingDressHall/inventory/' + id + '/update-remark ', params)
	},
	// 2021-09-22
	updateFlags(params) {
		return axios.put('/weddingDressHall/inventory/update-flags', params)
	},
	// 2021-09-22
	updateManualLockQuantity(id, params) {
		return axios.put('/weddingDressHall/inventory/' + id + '/update-manual-lock-quantity ', params)
	},

	// 2021-09-22
	delete(id) {
		return axios.delete('/weddingDressHall/inventory/' + id)
	},
	// 2021-09-22
	stockIn(id, params) {
		return axios.put('/weddingDressHall/inventory/' + id + '/stock-in', params)
	},
	// 2021-09-22
	stockOut(id, params) {
		return axios.put('/weddingDressHall/inventory/' + id + '/stock-out', params)
	},

	//   // 2020-11-07
	//   replenish(id, params) {
	//     return axios.post('/weddingDressHall/inventory/' + id + '/replenish', params)
	//   },


	//   // // 04-04
	//   // replenish(id, params) {
	//   //   return axios.post('/weddingDressHall/inventory/' + id + '/replenish', params)
	//   // },

	// 2021-09-22
	quickPhotoExportExcel(params) {
		return axios.get('/weddingDressHall/inventory/quick-photo-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// //2021-09-22
	// pendingStorageCount(params) {
	// 	return axios.get('/weddingDressHall/inventory/pending-storage-count', params)
	// },

	//   // 2020-12-19
	//   warnCount() {
	//     return axios.get('/weddingDressHall/inventory/warn-count')
	//   },

	//   // // 02-04
	//   // vagueFindByProductNo(params) {
	//   //   return axios.get('/weddingDressHall/inventory/vague-find-by-product-no', params)
	//   // },

	//   // 2020-09-14
	//   vagueFind(params) {
	//     return axios.get('/weddingDressHall/inventory/vague-find', params)
	//   },
	//   // 2021-09-14
	//   vagueFindInfoByProductNo(params) {
	//     return axios.get('/weddingDressHall/inventory/vague-find-info-by-product-no', params)
	//   },

	//   // 2020-12-10
	//   invInfoCount() {
	//     return axios.get('/weddingDressHall/inventory/inv-info-count')
	//   },

	//   // 2021-01-31
	//   findByOrderIds(params) {
	//     return axios.put('/weddingDressHall/inventory/find-by-order-ids', params)
	//   },
	// 2021-09-22
	exportExcel(params) {
		return axios.get('/weddingDressHall/inventory/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},


	// 2021-10-19
	lockList(id) {
		return axios.get('/weddingDressHall/inventory/' + id + '/lock-list')
	},

	// 2022-01-04
	searchUsableBySchedule(params) {
		return axios.get('/weddingDressHall/inventory/search-usable-by-schedule?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	//   // 2021-03-05
	//   adjustInventoryShelf(id, params) {
	//     return axios.put('/weddingDressHall/inventory/' + id + '/adjust-inventory-shelf', params)
	//   },
	//   // 2021-04-15
	//   report(params) {
	//     return axios.get('/weddingDressHall/inventory/report?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//   },
	//   // // 2021-04-15
	//   // reportExportExcel(params) {
	//   //   return axios.get('/weddingDressHall/inventory/report/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	//   // },

	//   // // 2021-05-26
	//   // batchExist(params) {
	//   //   return axios.post('/weddingDressHall/inventory/batch-exist', params)
	//   // },
	//   // 2021-05-26
	//   batchFindByProductInfo(params) {
	//     return axios.post('/weddingDressHall/inventory/batch-find-by-product-info', params)
	//   },
}

